module.exports = __webpack_public_path__ + "media/images/amenities_icons/wheelchair-03e0a78228f0fba9755a8264f8813991.svg";